"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Generated API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParamType = void 0;
/**
 *
 * @export
 * @enum {string}
 */
exports.ParamType = {
    TEXT: 'TEXT',
    NUMBER: 'NUMBER',
    LINK: 'LINK',
    DATE: 'DATE',
    FILE: 'FILE',
    IMAGE: 'IMAGE',
    MOMENT_NUMBER: 'MOMENT_NUMBER'
};
//# sourceMappingURL=param-type.js.map